import React, { useMemo } from 'react';
import SimpleModal from 'ui/Modals/SimpleModal';
import { ColDef } from 'ag-grid-community';
import HrDataGrid from 'routes/HumanResourcesModule/components/HrDataGrid/HrDataGrid';
import { useTranslation } from 'react-i18next';
import { getColDefs } from './helpers/colDefinitions';
import { HrSimulationOfficialGrade } from '../../helpers/types';
import { flattenHrSimulationOfficialGrade } from './helpers/dataHelpers';

type Props = {
    hrSimulationOfficialGradeData: HrSimulationOfficialGrade[];
    showModal: boolean;
    setShowModal: (arg: boolean) => void;
    isOfficialGradeDataLoading: boolean;
};

export default function OfficialGradeModal({
    hrSimulationOfficialGradeData,
    showModal,
    setShowModal,
    isOfficialGradeDataLoading,
}: Props) {
    const { t } = useTranslation();

    const gridData = !isOfficialGradeDataLoading
        ? flattenHrSimulationOfficialGrade(hrSimulationOfficialGradeData)
        : [];

    const columnDefs: ColDef[] = useMemo(() => getColDefs(t), []);
    const exportFileName = t('humanResources.simulation.officialGradeCSV');

    return (
        <SimpleModal
            open={showModal}
            onClose={() => setShowModal(false)}
            maxWidth="lg"
        >
            <HrDataGrid
                title={t('humanResources.simulation.officialGrade')}
                rowData={gridData}
                columnDefs={columnDefs}
                isLoading={isOfficialGradeDataLoading}
                exportFileName={exportFileName}
                showTotal={false}
                gridProps={{
                    paginationPageSize: 15,
                    rowGroupPanelShow: 'never',
                }}
            />
        </SimpleModal>
    );
}
